import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import SectionTitle from './SectionTitle';

const {FiDownload} = FiIcons;

const BASE = 'https://global.divhunt.com/';

const files = [
  'ffa1f3facb5ac403dcfaf5ade86dfa7c_49412.webp',
  '976bf52c5caef8dedb0ee21564441a10_87206.webp',
  'df56dc46479257527c569d365b0f27e7_36388.webp',
  '53952ba062444701b5e2d582c5697086_53644.webp',
  '56c958cc50d38fba52df1c4fd902e01b_73732.webp',
  '1d9d8a595333a8a115518d60b4ffcbe5_51208.webp',
  '648d86335bb5e6e60c4d39419c298911_43680.webp',
  '53ecd7e42b6e34906b4a5819ab8feb05_53980.webp',
  '032f3a5bae515ebc1b48f93e62ae120d_96788.webp',
  '3f2470cd160a97891f5894d133fdef3c_104141.avif',
  '8123b1e0f9c2cc2ceccc6a310a5a9d41_45848.webp',
  '447f7b47d29f6a7c9ee353c6fe74223f_66610.webp',
  '4c712d7faff5cfd66829a55702ceaae3_188892.webp',
  'a20d48fbd40bc446216ca44a3c421f04_44332.webp',
  'ebeab978b7b26d7da8f8b6a9c7e45ad0_118576.webp',
  '1a39f7fd27c2e7bb786d2aa664d0a450_58228.webp',
  '01ee760496aace98e18adcbb428d880e_96676.webp',
  '13401c4b20e1138b8873672251f46479_85246.webp',
  '2d7cf1dbda484c01a901daa8492b2d8f_50156.webp',
  'd7fc9b9cda7e47a89f42b36c1c35c712_52906.webp',
  '7f52ed57ae1aca0e28bdb7dc27cc5646_74708.webp',
  '55422061b62256cbf787c8fcf4cefedf_121750.webp',
  'f72a5650748e194c70357de6065e77ee_56320.webp',
  'd933a992bce51156b0da6ec0b9f3b271_61762.webp',
  'ec757409ee00e2f72fdfaae0c8586803_46628.webp',
  '60fa6fdc06e2dd5df626fe6d0740999a_125054.webp',
  '7aea83bc3536a60d4b887f90dc10ef9f_24682.webp',
  'a49fc8f3b8698b73c81c4bc55af47d98_53286.webp',
  '8abe855409e8f3d5d6f0b02231c36fb4_61272.webp',
  '0b2422d9deeb9684876c56caa79e4419_138356.webp',
  '0943a0af22e2f086cd937f84456ee60c_35700.webp',
  '8102d20b1e86a08c80e7251e78e6d3fd_68104.webp',
  '9f5bff3b8cbebd29bf0a27d1b414c784_170514.webp',
  'a5de7400cfdc7b292f1367fdce1f2f61_55582.webp',
  '5435b67816bdc2f71fd18879d4f84814_48034.webp',
  'e82912dd27bbd111b2ad9fd7e2170814_42632.webp',
  '114354b39c8eaa27b162bca69ec5fc69_105612.webp',
  '0479d91f41764dcc00a12d5a1ac292be_69116.webp',
  '03b4db77a1ec5bb184d4d7381fe9f54c_45450.webp',
  '4786f38c48c11bba691f4376e68d9be1_83996.webp',
  '1c8a300fea0ae5379510e32663ad2fec_83656.webp',
  '1f75a02591cfe61a056beb882031926a_147142.webp',
  'cd83063f5b2b2b8511f73c0fa6193c34_46602.webp',
  'd47f67ffc242a4387e6d3201ac5ac371_76330.webp',
  '6ba4d8f98f956912179cbca85eb8109b_133038.webp',
  '36a9fe29005784f6dfc402a023d75e25_86002.webp',
  'd12fdacda04700ee5689a5b43d9b0a01_44886.webp',
  '090e4f396cee9cc51a583e881778322f_108128.webp',
  '8fd4ddca2115730bbee19b05b4937634_77074.webp',
  'a6bafa079c200eab5c134a0db8f98009_49394.webp'
];

const ads = files.map((file, i) => ({
  name: `Ad ${i + 1}`,
  url: BASE + file,
  ext: file.split('.').pop()
}));

async function downloadImage(ad) {
  const filename = `jelly-local-ad-${ad.name.split(' ')[1]}.${ad.ext}`;
  try {
    const res = await fetch(ad.url);
    if (!res.ok) throw new Error('fetch failed');
    const blob = await res.blob();
    const href = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = href;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
  } catch (e) {
    window.open(ad.url, '_blank', 'noopener,noreferrer');
  }
}

export default function AdGraphics() {
  return (
    <div>
      <SectionTitle eyebrow="PPC ad graphics" title="Ready-made Meta ad creative.">
        Download these graphics and upload them to Meta Ads Manager for your Facebook and Instagram ads.
      </SectionTitle>
      <div className="mt-14 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {ads.map((ad) => (
          <div key={ad.url}>
            <img
              src={ad.url}
              alt={ad.name}
              loading="lazy"
              className="w-full rounded-3xl border border-slate-200 bg-slate-50"
            />
            <div className="mt-4 flex items-center justify-between">
              <p className="font-bold">{ad.name}</p>
              <button
                type="button"
                onClick={() => downloadImage(ad)}
                className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-4 py-2 text-xs font-semibold text-slate-600 hover:border-[#3fc0fa]"
              >
                <SafeIcon icon={FiDownload} /> Download
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}